import React from 'react';
import { Stepper, Step, StepLabel, StepButton, Box } from '@mui/material';
import '../styles/ProgressBar.css';

const ProgressStepper = ({ steps, setStep , stepLabels }) => {
    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 3 }}>
            <Stepper activeStep={steps - 1} alternativeLabel>
                {stepLabels.map((label, index) => (
                    <Step key={label}>
                        <StepButton onClick={() => index < steps && setStep(index + 1)}>
                            <StepLabel>{label}</StepLabel>
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export default ProgressStepper;
